export default "https://cdn-static.gokick.com/assets/31e0b9f53043906ee01608417204ccf2abfa2ab1/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";